import React from 'react'
import TubeBlockBannerr from "../components/img/TubeBlockBannerr.webp";
const TubeBlockBanner = () => {
  return (
    <div>
    <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src={TubeBlockBannerr} className="d-block w-100 carousel-image" alt="..." />
        </div>
      </div>
    </div>
  </div>
  )
}

export default TubeBlockBanner
